import { ApolloCache } from "@apollo/client"
import {
  PathItemFragment,
  SaveCompletionFeedbackMutationVariables,
  UserCompletionsNeedingReviewDocument,
  UserCompletionsNeedingReviewQueryResult,
  UserCompletionsNeedingReviewQueryVariables,
  useSaveCompletionFeedbackMutation as _useSaveCompletionFeedbackMutation
} from "../../api/generated"

// NOTE: currently no UIs use the USER_COMPLETIONS_NEEDING_REVIEW query.
// We may want to either update the cache or refetch the query used in useCompletions.
export const updateCacheOnReview =
  (
    userId: number,
    neededReview: boolean,
    getNeedsReview?: (result: any) => boolean
  ) =>
  (cache: ApolloCache<any>, result: any) => {
    const needsReview = getNeedsReview?.(result)

    let changeInNeedsReviewCount = 0
    if (neededReview !== needsReview) {
      if (neededReview && !needsReview) changeInNeedsReviewCount = -1
      if (!neededReview && needsReview) changeInNeedsReviewCount = 1
    }

    if (userId && changeInNeedsReviewCount) {
      // ...attempt to decrement any related needs review path item stats
      const query = UserCompletionsNeedingReviewDocument
      const variables = {
        user_id: userId
      }

      try {
        const data = cache.readQuery<
          UserCompletionsNeedingReviewQueryResult["data"],
          UserCompletionsNeedingReviewQueryVariables
        >({ query, variables })
        if (data) {
          const nextData = {
            pathItemStats: {
              ...data.pathItemStats,
              path_items_needing_review: Math.max(
                0,
                (data.pathItemStats?.path_items_needing_review || 0) +
                  changeInNeedsReviewCount
              )
            }
          }
          cache.writeQuery({ query, variables, data: nextData })
        }
      } catch (error) {
        console.log("error updating cache", error)
        // noop, query likey doesn't exist in the cache
      }
    }
  }

// NOT IN USE
const useSaveCompletionFeedbackMutation = (step: PathItemFragment) => {
  // cache whether this completion needed grading
  const neededReview = !!step.completion.needs_grading
  const userId = step.completion.user?.id!

  const [saveCompletionFeedbackMutation, { loading, error }] =
    _useSaveCompletionFeedbackMutation({
      variables: {
        id: step.id,
        pathId: step.path_id
      } as SaveCompletionFeedbackMutationVariables,
      update: updateCacheOnReview(userId, neededReview)
    })

  return [saveCompletionFeedbackMutation, { loading, error }]
}

export default useSaveCompletionFeedbackMutation
